<template>
    <div>
        <el-form :inline="true" :model="formInline" ref="queryForm" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-row>
                <el-form-item label="userId" prop="userId">
                    <el-input v-model="formInline.userId" placeholder="userId"></el-input>
                </el-form-item>
                <el-form-item label="主订单号" prop="orderMainNo">
                    <el-input v-model="formInline.orderMainNo" placeholder="主订单号"></el-input>
                </el-form-item>
                <el-form-item label="子订单号" prop="orderNo">
                    <el-input v-model="formInline.orderNo" placeholder="子订单号"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item label="开始日期">
                <el-date-picker
                        v-model=formInline.beginCreateTime
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
                <el-date-picker
                        v-model=formInline.endCreateTime
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <!-- <el-button @click="resetForm('queryForm')">清空</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="userId" label="userId"  width="120"></el-table-column>
            <el-table-column prop="orderMainNo" label="主订单号" width="100"></el-table-column>
            <el-table-column prop="orderNo" label="子订单号" width="100"></el-table-column>
            <el-table-column prop="createTime" label="评价时间" width="140"></el-table-column>
            <el-table-column prop="evaluate" label="评价内容"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="orderDetails(scope.row)">订单详情</el-button>
                    <el-button type="primary" size="mini" @click="productDetails(scope.row)">商品详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="订单详情" :visible.sync="dialogFormVisible">
          <el-form :model="orderForm">
            <el-form-item label="userId">
                <el-input v-model="orderForm.userId" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="主订单">
                <el-input v-model="orderForm.orderMainNo" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="子订单">
                <el-input v-model="orderForm.orderNo" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="省">
                <el-input v-model="orderForm.province" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="市">
                <el-input v-model="orderForm.city" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="区">
                <el-input v-model="orderForm.area" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="星级">
                <el-input v-model="orderForm.flag" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="是否自动评价">
                <el-input v-model="orderForm.autoEvaluate" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="评价时间">
                <el-input v-model="orderForm.createTime" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="评价内容">
                <el-input type="textarea" v-model="orderForm.evaluate" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="好评标签">
                <el-input v-model="orderForm.goodTags" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="差评标签">
                <el-input v-model="orderForm.badTags" :disabled="true"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <el-dialog title="订单商品评价" :visible.sync="dialogTableVisible">
          <el-table :data="productData">
            <el-table-column property="orderNo" label="订单号" width="150"></el-table-column>
            <el-table-column property="productId" label="商品ID" width="200"></el-table-column>
            <el-table-column property="prodcutName" label="商品名称"></el-table-column>
            <el-table-column property="prodcutFlag" label="星级"></el-table-column>
            <el-table-column property="productComment" label="评价内容"></el-table-column>
            <el-table-column property="autoEvaluate" label="是否自动评价" :formatter="formatAutoEvaluate"></el-table-column>
            <el-table-column property="addEvaluateTimes" label="第几次追加评价"></el-table-column>
            <el-table-column property="source" label="进入评价页面的来源"></el-table-column>
            <el-table-column property="createTime" label="创建时间"></el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">关闭</el-button>
        </div>
        </el-dialog>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getEvaluateOrderListByPage,getEvaluateOrderDetail,getEvaluateOrderProductList,getEvaluateOrderProductListByPage} from '../../api/api';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                productData:[],
                loading:true,
                dialogFormVisible:false,
                dialogTableVisible: false,
                orderForm:{
                    "tid" : "",
                    "userId":"",
                    "orderMainNo":"",
                    "orderNo":""
                },
                formInline:{
                    userId:"",
                    orderMainNo:"",
                    orderNo:"",
                    beginCreateTime:"",
                    endCreateTime:"",
                    platformId:0,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0
                },
                queryForm:{
                    userId:'',
                    orderMainNo:'',
                    orderNo:''
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods:{
            //状态类型转换
            formatAutoEvaluate: function (row, column) {
                return row.autoEvaluate == 0 ? '不是' : row.autoEvaluate == 1 ? '是' : '未知';
            },
            //定义查询方法
            getList(){
                this.loading = true;
                getEvaluateOrderListByPage(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.listData = res.data.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            //清空
            //resetForm(formName) {
                  //this.$refs[formName].resetFields();
                  //this.formInline.userId = '';
                  //this.formInline.orderMainNo = '';
                  //this.formInline.orderNo = '';
            //},

            //订单详情
            orderDetails(row){
                this.dialogFormVisible = true;
                getEvaluateOrderDetail({tid:row.tid}).then((res) => {
                    var evaluateOrderDetail = res.data;
                    this.orderForm.userId = evaluateOrderDetail.userId;
                    this.orderForm.orderMainNo = evaluateOrderDetail.orderMainNo;
                    this.orderForm.orderNo = evaluateOrderDetail.orderNo;
                    this.orderForm.province = evaluateOrderDetail.province;
                    this.orderForm.city = evaluateOrderDetail.city;
                    this.orderForm.area = evaluateOrderDetail.area;
                    this.orderForm.flag = evaluateOrderDetail.flag;
                    this.orderForm.evaluate = evaluateOrderDetail.evaluate;
                    this.orderForm.goodTags = evaluateOrderDetail.goodTags;
                    this.orderForm.badTags = evaluateOrderDetail.badTags;
                    if(evaluateOrderDetail.autoEvaluate == 1){
                        this.orderForm.autoEvaluate = "是";
                    }else{
                        this.orderForm.autoEvaluate = "否";
                    }
                    this.orderForm.createTime = evaluateOrderDetail.createTime;
                })
            },
            //商品详情
            productDetails(row){
                this.dialogTableVisible = true;
                getEvaluateOrderProductList({orderNo:row.orderNo}).then((res) => {
                    this.productData = res.data;
                })
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/views/mallevaluate/mallEvaluate.vue